export enum EditableFieldsNames {
  Action = 'action',
  Id = 'id',
  Status = 'status',
  Update = 'update',
}
